/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCutleryHeart = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M16.5 5.236 18.997 8l2.5-2.764c.322-.358.502-.839.502-1.34 0-.5-.18-.981-.503-1.34a1.72 1.72 0 0 0-.559-.41 1.586 1.586 0 0 0-1.323 0 1.684 1.684 0 0 0-.557.41l-.06.07-.06-.07c-.159-.175-.349-.315-.558-.41S17.946 2 17.72 2c-.227 0-.452.05-.662.145s-.399.236-.558.412c-.32.36-.499.84-.499 1.34 0 .5.179.98.5 1.339zM2 2h2v8h1V2h2v8h1V2h2v10a4.002 4.002 0 0 1-3 3.874V22H5v-6.126A4.002 4.002 0 0 1 2 12zm4 12a2 2 0 0 0 2-2H4a2 2 0 0 0 2 2z" />
        <path d="M14 9c0-1.128.232-2.148.606-2.968a4.048 4.048 0 0 1-.567-2.695 5.963 5.963 0 0 0-.7.866C12.493 5.474 12 7.173 12 9c0 1.827.492 3.526 1.34 4.797.653.98 1.565 1.764 2.66 2.067V22h2v-6.136c1.095-.303 2.007-1.087 2.66-2.067C21.508 12.526 22 10.827 22 9c0-.425-.027-.844-.078-1.251l-1.976 2.185c-.13 1.096-.479 2.048-.95 2.754C18.392 13.595 17.666 14 17 14s-1.392-.405-1.996-1.312C14.404 11.788 14 10.487 14 9z" />
      </g>
    </g>
  </Icon>
);
export { SvgCutleryHeart as CutleryHeart };
